import {
  SAAS_SUBSCRIPTION_CUSTOM_RULES,
  SAAS_SUBSCRIPTION_LIMITS_DATA_TYPES,
} from '@shared/constants';
import { ILimitsQuotesConfig } from '@shared/interfaces';

const limitations: ILimitsQuotesConfig[] = [
  {
    key: SAAS_SUBSCRIPTION_CUSTOM_RULES.NO_OF_USERS,
    displayValue: 'Number Of Users',
    is_multiple: false,
    required: false,
    val_1: {
      type: SAAS_SUBSCRIPTION_LIMITS_DATA_TYPES.NUMBER,
      displayValue: 'Count',
      placeHolder: '3500',
      required: true,
    },
  },
];

export const saasLimitationGenerator = (): ILimitsQuotesConfig[] => {
  return limitations;
};
